import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { JwtHelperService} from '@auth0/angular-jwt'

@Injectable()
export class DataServ {
  
  helper = new JwtHelperService();

  private messageSource = new BehaviorSubject('Home');
  private customload = new BehaviorSubject('');
  currentMessage = this.messageSource.asObservable();
  currentLoad = this.customload.asObservable();

  private userAcc = new BehaviorSubject('user');
  currentUser = this.userAcc.asObservable();

  private userRole = new BehaviorSubject('');
  currentRole = this.userRole.asObservable();

  private etllastupload = new BehaviorSubject('');
  etlLastUpdate = this.etllastupload.asObservable();

  EmpId = 447;
  constructor() { }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  changeUser(user: string) {
    this.userAcc.next(user);
  }
  
  changeRole(role: string) {
    this.userRole.next(role);
    
  }

  tokenExpired(token: string) {
    debugger;
    let isexp = true;
    if (token != null && token != "")
      isexp = Boolean(this.helper.isTokenExpired(token)).valueOf();
    return isexp;
  }

  changeETlLastUpdate(etllastupdate: string) {
    this.etllastupload.next(etllastupdate);
  }

  
}
